import {useSetRecoilState} from "recoil";
import {cartState, deliveryInfoState, loadingPageState, orderState} from "../../../state";
import {useSearchParams} from 'react-router-dom'
import {sendRequestAuth} from "../../../api/api";
import {CONFIG} from "../../../api/config";
import region from "utils/_data.json"

export const useOrderDetails = () => {

   const [searchParams] = useSearchParams()
   const orderId = searchParams.get('id') || ''
   const hashOrder = searchParams.get('hash') || ''
   const setOrder = useSetRecoilState(orderState)
   const setDeliveryInfoState = useSetRecoilState(deliveryInfoState)
   const setLoadingState = useSetRecoilState(loadingPageState)
   const setCartOrder = useSetRecoilState(cartState)
   // call API get order

   const getOrderDetail = async () => {
      setLoadingState(true)
      const response = await sendRequestAuth('get', `${CONFIG.API}/order/detail/${orderId}?hash=${hashOrder}`)
      if(!!response.data?.success){

         setLoadingState(false)
         const order = response.data?.data
            setOrder(order)
            setCartOrder(order?.order_details)
            const province = region.find(item => item.id === order.city_id)
            const ward = province?.list.find(item => item.id === order.ward_id)

            setDeliveryInfoState(prev => ({
               phoneNumber: {...prev.phoneNumber, value: order.customer_mobile},
               receiverName: {...prev.receiverName, value: order.customer_name},
               address: {value: order.customer_address, validate: prev.address.validate},
               province: {...prev.province, value: province},
               ward: {...prev.ward, value: ward, list: province?.list || [], listOrigin: province?.list || []},
               notes: order.note || ''
            }))
      }else{
         setLoadingState(false)
      }
   }

   return {getOrderDetail}

}